import { render } from "./UserNavLink.vue?vue&type=template&id=000e6333"
import script from "./UserNavLink.vue?vue&type=script&lang=js"
export * from "./UserNavLink.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__